import React from 'react';
import { Outlet } from 'react-router-dom';
import RequireAuth from '../guards/RequireAuth';
import RequireEmailVerification from '../guards/RequireEmailVerification';
import RequireTwoFactorSetup from '../guards/RequireTwoFactorSetup';
import RequireTwoFactorVerification from '../guards/RequireTwoFactorVerification';

const ProtectedLayout = () => {
  return (
    <RequireAuth>
      <RequireEmailVerification>
        <RequireTwoFactorSetup>
          <RequireTwoFactorVerification>
            <Outlet /> {/* Renders child routes */}
          </RequireTwoFactorVerification>
        </RequireTwoFactorSetup>
      </RequireEmailVerification>
    </RequireAuth>
  );
};

export default ProtectedLayout;
